import template from './me-detail.html';
import controller from './me.controller';
import './me.scss';

let meComponent = {
  bindings: {},
  template,
  controller
};

export default meComponent;



// WEBPACK FOOTER //
// ./client/app/components/me/me.component.js